<template>
  <div>
    <GoBackButton class="text-left" />
    <b-card style="background: #f1f1f1">
      <MyCandidatesFilter
        :filter="filter"
        :options="options"
      />
      <pagination
        v-if="paginationMeta"
        :data="paginationMeta"
        size="small"
        :limit="1"
        align="center"
        @pagination-change-page="fetchCandidates"
      />
      <div
        v-for="candidate in candidates.object"
        :key="candidate.id"
        class="text-left"
      >
        <offerCandidateCard :candidate="candidate" />
      </div>
      <pagination
        v-if="paginationMeta"
        :data="paginationMeta"
        size="small"
        :limit="1"
        align="center"
        @pagination-change-page="fetchCandidates"
      />
      <div
        v-if="!paginationMeta || paginationMeta.data && paginationMeta.data.length === 0"
        class="mt-5 mb-5"
      >
        {{ $t('pages.my-candidates.no-candidates', 'No candidates yet') }}
      </div>
    </b-card>
  </div>
</template>

<script>
import GoBackButton from '@/components/jobs/shared/GoBackButton';
import MyCandidatesFilter from "@/components/jobs/employer/MyCandidatesFilter";
import offerCandidateCard from "@/components/jobs/blocks/offerCandidateCard";

export default {
  components: {
    GoBackButton,
    MyCandidatesFilter,
    offerCandidateCard
  },

  data() {
    return {
      filter: {
        keyword: '',
        status: 'new',
        order: '',
      },
      candidates: {},
      paginationMeta: null,
      debounce: null,
      mountInit: true,
      page: 1,
    }
  },

  computed: {
    options() {
      return {
        filter: {
          status: [
            { value: 'new', text: this.$t('pages.my-candidates.filters.status.new', 'New') },
            { value: 'seen', text: this.$t('pages.my-candidates.filters.status.seen', 'Seen') },
            { value: 'inprocess', text: this.$t('pages.my-candidates.filters.status.inprocess', 'In process') },
            { value: 'accepted', text: this.$t('pages.my-candidates.filters.status.accepted', 'Accepted') },
            { value: 'rejected', text: this.$t('pages.my-candidates.filters.status.rejected', 'Rejected') },
            { value: 'invalid', text: this.$t('pages.my-candidates.filters.status.invalid', 'Invalid') },
          ],
          order: [
            { value: '', text: this.$t('pages.my-candidates.filters.order.date', 'Sort by application date') },
            { value: 'candidate', text: this.$t('pages.my-candidates.filters.order.candidate', 'Sort by candidate') },
            { value: 'last_change', text: this.$t('pages.my-candidates.filters.order.last_change', 'Sort by latest update') },
            { value: 'offer_creation', text: this.$t('pages.my-candidates.filters.order.offer_creation', 'Sort by offer date') },
          ]
        }
      }
    }
  },

  watch: {
    filter: {
      handler() {
        if (!this.mountInit) {
            this.page = 1;
        }

        this.mountInit = false;
        this.updateQueryParams();
        this.debounceFetchCandidates();
      },
      deep: true,
    },
  },

  mounted() {
    let queryParams = { ...this.$route.query };
    delete queryParams.page;
    this.filter = { ...this.filter, ...queryParams };
    this.page = this.$route.query.page;
  },

  methods: {
    fetchCandidates(page) {
      // Default page value to:
      // - function call parameter
      // - filter 'page' parameter
      // - 1 (first page if nothing else is available)
      page = page || this.page || 1;

      this.$router.replace({ query: { ...this.$route.query, page }});
      this.axios.get('/offerApply/myCandidates/' + this.filter.status, { params: { ...this.filter, page }})
        .then(response => {
            this.candidates = ({ object: response.data.data });
            this.paginationMeta = response.data;
            if (response.data.current_page > response.data.last_page) {
                this.fetchCandidates(response.data.last_page);
            }
        })
        .catch();
    },

    debounceFetchCandidates() {
      if (this.debounce) {
          clearTimeout(this.debounce);
      }

      this.debounce = setTimeout(this.fetchCandidates, 750);
    },

    updateQueryParams() {
        let queryParams = {};

        for (let param in this.filter) {
            if (!this.filter.hasOwnProperty(param)) continue;
            queryParams[param] = this.filter[param];
        }

        queryParams.page = this.page;
        this.$router.replace({ query: queryParams,  });
    }
  },
}
</script>
